import { datadogLogs } from '@datadog/browser-logs';
import { config } from '../config';

const envLocation = `[${config.serviceName}]`;

/* eslint-disable no-console */
export const trace = {
    debug: (...args: any) =>
        import.meta.env.DEV ? console.debug(envLocation, ...args) : datadogLogs.logger.debug(envLocation, ...args),
    info: (...args: any) =>
        import.meta.env.DEV ? console.info(envLocation, ...args) : datadogLogs.logger.info(envLocation, ...args),
    warn: (...args: any) =>
        import.meta.env.DEV ? console.warn(envLocation, ...args) : datadogLogs.logger.warn(envLocation, ...args),
    error: (...args: any) =>
        import.meta.env.DEV ? console.error(envLocation, ...args) : datadogLogs.logger.error(envLocation, ...args),
};
